var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMozambique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48614 16.6956L3.51511 20.4849C5.68654 22.6566 8.68622 24 12 24C16.9608 24 21.2177 20.9893 23.0452 16.6956H6.48614Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0639 7.3478C21.2466 3.03103 16.9776 0 12 0C8.68622 0 5.68654 1.34339 3.51511 3.51511L6.52026 7.3478H23.0639Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60867 8.82608V15.1304H23.5866C23.8558 14.1324 24 13.0831 24 12C24 10.9011 23.852 9.83708 23.5753 8.82608H2.60867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51468 3.51468C-1.1716 8.20096 -1.1716 15.799 3.51468 20.4853C5.45123 18.5488 7.31371 16.6863 12 12L3.51468 3.51468Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85673 8.86954L5.63368 11.2609H8.14834L6.11406 12.739L6.89097 15.1304L4.85673 13.6524L2.8224 15.1304L3.5995 12.739L1.56522 11.2609H4.07968L4.85673 8.86954Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58313 12H7.13113V14.087H2.58313V12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 9.60744L7.25433 8.86954L4.85677 11.2671L2.4592 8.86954L1.72134 9.60744L4.12102 12.0029L1.72134 14.4026L2.4592 15.1304L4.85677 12.7372L7.25433 15.1304L7.99219 14.4026L5.59252 12.0029L7.99219 9.60744Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMozambique);
export default __webpack_public_path__ + "static/media/mozambique.f1bd3454ba7b8e23b388f23c8088ba56.svg";
export { ForwardRef as ReactComponent };